import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MAddressListRequest, MAddressListResponse, MAddressRequest, MAddressResponse, MOrderDetailRequest, MOrderDetailResponse, MUpdateOrderStatusRequest, MUserProfileRequest, MUserProfileResponse, MWishlistResponse } from 'src/app/pages/user/user.module';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsUserProfileService {

  constructor(private httpClient: HttpClient) { }
   
 /**
 * Date:- 13-06-2023
 * Method :- This method is used for Get Profile Details By Id
 * @param id  This param is used for Get Profile Details By Id
 * @returns 
 */
  getUserProfile(userId: MUserProfileRequest): Observable<MUserProfileResponse> {
    const id = "id=" + userId.id;
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.post<MUserProfileResponse>(UtilsService.BASE_URL + UtilsService.USERPROFILE + '?' + id, { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

 /**
 * Date:- 13-06-2023
 * Method :- This method is used for Get Address List By userId
 * @param userId  This param is used for Get Address List By userId
 * @returns 
 */
  getAddressList(id: MAddressListRequest): Observable<MAddressListResponse> {
    const userId = "userId=" + id.userId;
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.post<MAddressListResponse>(UtilsService.BASE_URL + UtilsService.ADDRESSLIST + '?' + userId, { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used for Add Address 
  * @param addAddress :-  This is used for Add Address 
  * @returns 
  */
  addAddress(addAddress: MAddressRequest): Observable<MAddressResponse> {
    var jsonBody = JSON.stringify(addAddress)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MAddressResponse>(UtilsService.BASE_URL + UtilsService.ADDADDRESS, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used for Update Address 
  * @param updateAddress :-  This is used for Update Address 
  * @returns 
  */
  updateAddress(updateAddress: MAddressRequest): Observable<MAddressResponse> {
    var jsonBody = JSON.stringify(updateAddress)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MAddressResponse>(UtilsService.BASE_URL + UtilsService.UPDATEADDRESS, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

 /**
 * Date:- 13-06-2023
 * Method :- This method is used for Remove Address
 * @param addressId  This param is used for Remove Address 
 * @returns 
 */
  removeAddress(addressId: any): Observable<MAddressListResponse> {
    const id = "id=" + addressId;
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.post<MAddressListResponse>(UtilsService.BASE_URL + UtilsService.REMOVEADDRESS + '?' + id, { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

 /**
 * Date:- 14-06-2023
 * Method :- This method is used for Get Order Detail List By userId
 * @param orderReq  This param is used for Get Order Detail List By userId
 * @returns 
 */
   getOrderDetailList(orderReq: MOrderDetailRequest): Observable<MOrderDetailResponse> {
    var jsonBody = JSON.stringify(orderReq)
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.post<MOrderDetailResponse>(UtilsService.BASE_URL + UtilsService.ORDERLIST , jsonBody , { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

   /**
 * Date:- 14-06-2023
 * Method :- This method is used for Get Order Detail List By userId
 * @param orderReq  This param is used for Get Order Detail List By userId
 * @returns 
 */
   getOrderDetail(orderId: any): Observable<any> {
    var param = '?orderId='+ orderId
    const headers = {
      'Content-Type': 'application/json'
    }
    return this.httpClient.get<any>(UtilsService.BASE_URL + UtilsService.ORDERDETAIL + param , { headers: headers })
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
  
  /**
  * Date:- 21-06-2023
  * Method :- This method is used for Get WishList List By userId 
  * @param userId  This param is used for Get WishList  List By userId 
  * @returns 
  */
  getWishList(id:string): Observable<MWishlistResponse> {
    const userId = id;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
      return this.httpClient.get<MWishlistResponse>(UtilsService.BASE_URL + UtilsService.GETWISHLISTBYUSER +'?userId='+userId , httpOptions)
        .pipe(
          map(response => {
            return response;
          }), catchError(UtilsService.ErrorHandler.handleError('getData'))
        )
    }

     /**
 * Api for updating order status
 * @returns 
 */
  updateOrderStatus(mUpdateOrderStatusReq: MUpdateOrderStatusRequest): Observable<any> {
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.UPDATEORDERSTATUS, mUpdateOrderStatusReq).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }
     

  updateProfile(profileData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.UPDATEPROFILE, profileData,httpOptions).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }

  checkPinCode(pincode:any): Observable<any> {
    return this.httpClient.get<any>('https://api.postalpincode.in/pincode/' + pincode).pipe(
      map(response => {
        return response;
      }), catchError(UtilsService.ErrorHandler.handleError('getData')));
  }
}
